import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/PageWrapper.scss';

const ChatMessage = ({
  isSentByUser, message,
}) => (
  <div
    data-testid={isSentByUser ? 'user-message' : 'api-message'}
    className={`${isSentByUser && 'flex-justify-end'} flex width-full pad-1-tb`}
  >
    <div
      className={`pad-2-lr body-3 ${styles.chatBubble} ${
        isSentByUser ? `${styles.userSentMessage}` : `${styles.aiSentMessage}`}`}
      style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
    >
      {message}
    </div>
  </div>
);

export default ChatMessage;

ChatMessage.propTypes = {
  isSentByUser: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};
